export const questionTypeMask = (type: string) => {
  if (type === 'select_option_metadata_comments') return 'select_option_metadata';
  if (type === 'multi_photo') return 'photo';
  return type;
};

export const ALL_METADATA_TYPES = [
  'select_option_metadata',
  'select_option_metadata_comments',
  'select_check_metadata',
  'select_number_metadata',
  'select_text_metadata',
  'select_metadata',
  'select_activity_period_time',
];
